export const testAttributes = {
    EDITORIALDISCLOUSURE_MAIN_CONTAINER: 'editorialdisclosure_main_container',
    EDITORIALDISCLOUSURE_MODAL: 'editorialdisclosure_modal',
};

export const defaultAttributes = {
    LABEL: 'Editorial Disclosure',
};